import type { CSSProperties } from 'react';

export interface TabItem {
  id: string;
  label: string;
}

export interface TabsProps {
  tabs: TabItem[];
  activeId?: string;
  onSelect?: (id: string) => void;
  ariaLabel?: string;
  style?: CSSProperties;
}

/** Pill view switcher: one navy active pill over a sunken track. */
export function Tabs({ tabs, activeId, onSelect, ariaLabel, style }: TabsProps) {
  return (
    <div role="tablist" aria-label={ariaLabel} className="fs-tabs" style={style}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={tab.id === activeId}
          className="fs-tab"
          onClick={() => onSelect?.(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
